import React, { useState, useEffect } from 'react';
import { useFormService } from '../core/form-service';
import { FORM_STATES, FORM_EVENTS } from '../machine/machine-config';
import { ViewFetcher } from '../data/view-fetcher';
import { RepositoryFetcher } from '../data/repository-fetcher';

export const DynamicFetcher = () => {
  const { state, send } = useFormService();
  const isFetching = state.matches(FORM_STATES.FETCHING);

  const [isViewFetched, setIsViewFetched] = useState(false);
  const [isRepositoryFetched, setIsRepositoryFetched] = useState(false);

  useEffect(() => {
    if (isViewFetched && isRepositoryFetched && isFetching) {
      send(FORM_EVENTS.DONE_FETCHING);
    }
  }, [isFetching, isRepositoryFetched, isViewFetched, send]);

  return (
    <>
      <ViewFetcher isViewFetched={isViewFetched} setIsViewFetched={setIsViewFetched} />
      <RepositoryFetcher isRepositoryFetched={isRepositoryFetched} setIsRepositoryFetched={setIsRepositoryFetched} />
    </>
  );
};
